(() => {
  // variant-selectsごとに最後の選択値を保持
  const lastValueByVS = new Map();

  const isColor = (name) => {
    const n = String(name || "").trim().toLowerCase();
    return n === "color" || n === "colour" || n.includes("カラー");
  };

  const updateOne = (vs) => {
    if (!vs) return;

    // COLOR fieldset を探す（SIZEがあってもOK）
    const fieldsets = vs.querySelectorAll("fieldset");
    let colorFieldset = null;
    let legend = null;

    for (const fs of fieldsets) {
      const lg = fs.querySelector('legend.form__label[data-option-name]');
      if (!lg) continue;
      const optName = lg.dataset.optionName || lg.textContent;
      if (isColor(optName)) {
        colorFieldset = fs;
        legend = lg;
        break;
      }
    }
    if (!colorFieldset || !legend) return;

    // 現在のcheckedを取得（なければ記憶値を使う）
    const checked = colorFieldset.querySelector('input[type="radio"]:checked');
    const value =
      (checked && checked.value) ||
      lastValueByVS.get(vs.id || vs.getAttribute("data-section") || "default");

    if (!value) return;

    // 記憶して反映
    lastValueByVS.set(vs.id || vs.getAttribute("data-section") || "default", value);
    legend.setAttribute("data-selected-value", value);
  };

  const reapplySoon = (vs) => {
    updateOne(vs);
    requestAnimationFrame(() => updateOne(vs));
    setTimeout(() => updateOne(vs), 50);
    setTimeout(() => updateOne(vs), 150);
  };

  const attachVSObserver = (vs) => {
    if (!vs || vs.dataset.legendSelectedObserver) return;
    vs.dataset.legendSelectedObserver = "1";

    const mo = new MutationObserver(() => updateOne(vs));
    mo.observe(vs, { childList: true, subtree: true });
  };

  const boot = () => {
    document.querySelectorAll("variant-selects").forEach((vs) => {
      attachVSObserver(vs);
      reapplySoon(vs);
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // radio変更を確実に拾う
  document.addEventListener("change", (e) => {
    const el = e.target;
    if (!el || !el.matches('variant-selects input[type="radio"]')) return;
    const vs = el.closest("variant-selects");
    reapplySoon(vs);
  });

  // クリックも拾う（モバイルやlabelタップの取りこぼし対策）
  document.addEventListener("click", (e) => {
    const vs = e.target && e.target.closest ? e.target.closest("variant-selects") : null;
    if (!vs) return;
    reapplySoon(vs);
  });

  // Dawnのイベント（来る環境では強い）
  document.addEventListener("variantChange", (e) => {
    const vs = e.target && e.target.closest ? e.target.closest("variant-selects") : null;
    if (vs) reapplySoon(vs);
  });

  // ✅ variant-selects 自体が差し替えられるケースに備えて、documentも監視して付け直す
  const docObserver = new MutationObserver(() => {
    document.querySelectorAll("variant-selects").forEach((vs) => {
      attachVSObserver(vs);
      updateOne(vs);
    });
  });
  docObserver.observe(document.documentElement, { childList: true, subtree: true });
})();